import * as tslib_1 from "tslib";
import { Component } from "vue-property-decorator";
import { NumberInputControl } from "@cloudpivot/form/src/common/controls/input-controls/number-input-control";
import numberFilter from "@cloudpivot/form/utils/number-filter";
import PcInputNumber from './pc-input-number.vue';
let MobileInputNumber = class MobileInputNumber extends NumberInputControl {
    constructor() {
        super(...arguments);
        this.value = '';
        this.hasValue = false;
    }
    get showClear() {
        return !this.readonly && this.hasValue;
    }
    onFocus() {
        this.onChange();
    }
    onChange() {
        const _ctrl = this.ctrl;
        this.hasValue = _ctrl.hasValue;
    }
    destroyed() {
        super.destroyed();
        if (this.subscription) {
            this.subscription.unsubscribe();
            this.subscription = undefined;
        }
    }
};
MobileInputNumber = tslib_1.__decorate([
    Component({
        name: "input-number",
        components: {
            PcInputNumber
        },
        filters: {
            number: numberFilter
        }
    })
], MobileInputNumber);
export default MobileInputNumber;
